import LocalizedFileInput from 'components/Erp/LocalizedFileInput';
import { getLocale } from 'i18n';
import { tr } from 'i18n';
import { useTranslation as useInterfaceLanguage } from 'react-i18next';
import { SectionHeading, EmptyState } from 'components/Erp/Presentation';
import { Plus, Pencil, FileText, Save, X, ChevronLeft, ChevronRight, UsersRound } from 'lucide-react';
import React from 'react'
import ResponsiveTable from './ResponsiveTable'
import AuditButton from './AuditButton'
import OperatorPinResetAction from './OperatorPinResetAction'
import OperatorInnChangeAction from './OperatorInnChangeAction'
import { DateTime, StatusBadge } from 'components/Erp/Display'
import styles from '../AdminPanelPage.module.scss'

const OperatorsList = ({ tb, operators = [], operatorsFilter = '', setOperatorsFilter = () => {},openCreateModal, loadOperatorsByTopBasePage = () => {}, employees = [], editingOperatorByTopBase, editPayloads = {}, setEditPayloads = () => {}, startEdit = () => {}, saveEdit = () => {}, cancelEdit = () => {}, operatorsPagination = {}, expandedOperatorByTopBase = {}, toggleOperator = () => {} }) => {
  useInterfaceLanguage();
  return (
    <div style={{ marginTop: 12 }}>
      <SectionHeading icon={UsersRound} title={tr("Операторы этой ТОП-базы")} as="h3" actions={<div className={styles.actionGroup}>
          <button className={`${styles.smallBtn} ${styles.addButton}`} onClick={() => openCreateModal('operator', { top_base: tb.id, top_base_name: tb.name })}><Plus size={14} aria-hidden="true"/>{tr(" Добавить оператора")}</button>
        </div>} />
      <div style={{ marginTop: 8 }}>
        <div className={styles.searchRow}>
          <input className={styles.searchInput} placeholder={tr("Поиск...")} value={operatorsFilter || ''} onChange={(e) => setOperatorsFilter(e.target.value)} onKeyDown={(e) => { if (e.key === 'Enter') loadOperatorsByTopBasePage(tb.id, 1, operatorsFilter || '') }} />

        </div>
        {(operators && operators.length) ? (
          <>
            <ResponsiveTable className={styles.table}>
              <thead>
                <tr>
                  <th>№</th>
                  <th>{tr("Сотрудник")}</th>
                  <th>{tr("Номер телефона")}</th>
                  <th>{tr("Дополнительный ном.тел")}</th>
                  <th>{tr("Создано")}</th>
                  <th>{tr("Статус")}</th>
                  <th>{tr("Действия")}</th>
                </tr>
              </thead>
              <tbody>
                {operators.filter(op => {
                  const q = (operatorsFilter || '').toLowerCase()
                  if (!q) return true
                  const emp = op.employee_name || String(op.employee)
                  return (emp && emp.toLowerCase().includes(q)) || (op.phone && String(op.phone).toLowerCase().includes(q))
                }).map((op, index) => (
                  <React.Fragment key={op.id}>
                    <tr style={{ cursor: 'pointer' }} onClick={() => toggleOperator(tb.id, op.id)}>
                      <td>{tr(index + 1)}</td>
                      <td>{tr(op.employee_name || op.employee)}</td>
                      <td>{tr(op.employee_phone || '-')}</td>
                      <td>{tr(op.phone || '-')}</td>
                      <td><DateTime value={op.created_at}/></td>
                      <td><StatusBadge tone={op.is_active ? 'success' : 'danger'}>{op.is_active ? tr("Активен") : tr("Неактивен")}</StatusBadge></td>
                      <td>
                        <div className={styles.actionGroup}>
                          <button className={`${styles.smallBtn} ${styles.editBtn}`} aria-expanded={editingOperatorByTopBase?.[tb.id] === op.id} onClick={(ev) => { ev.stopPropagation(); startEdit('operator', { topBase: tb.id, opId: op.id }, { phone: op.phone, is_active: op.is_active, employee: op.employee }) }}><Pencil size={14} aria-hidden="true"/>{tr(" Изменить")}</button><OperatorPinResetAction operator={op} onChanged={() => loadOperatorsByTopBasePage(tb.id, operatorsPagination.page || 1, operatorsFilter)} /><OperatorInnChangeAction operator={op} onChanged={() => loadOperatorsByTopBasePage(tb.id, operatorsPagination.page || 1, operatorsFilter)} /><AuditButton section="top_bases" objectId={op.id} objectType="tabel.TopBaseOperator"/>
                        </div>
                      </td>
                    </tr>
                    {tr(expandedOperatorByTopBase[tb.id] === op.id && (
                      <tr>
                        <td colSpan={7} style={{ textAlign: 'start', padding: 12 }}>
                          <div style={{ display: 'inline-block', position: 'relative', textAlign: 'left', width: '100%' }}>
                            {/* Документы оператора */}
                            <div style={{ marginTop: 16, borderTop: "1px solid var(--theme-border, #e0e0e0)", paddingTop: 12 }}>
                              <strong>{tr("Документы оператора:")}</strong>
                              {op.documents && op.documents.length > 0 ? (
                                <ul style={{ marginTop: 8, paddingLeft: 20 }}>
                                  {op.documents.map(doc => (
                                    <li key={doc.id} style={{ marginBottom: 8 }}>
                                      <a href={doc.file_url} target="_blank" rel="noopener noreferrer" style={{ color: "var(--theme-primary-text, #0d00f3)", textDecoration: 'none' }}>
                                        {tr(doc.file_name)}
                                      </a>
                                      <span style={{ marginLeft: 8, color: "var(--theme-text-muted, #666)", fontSize: '12px' }}>
                                        ({(doc.file_size / 1024).toFixed(1)}{tr(" КБ) - ")}{new Date(doc.uploaded_at).toLocaleString(getLocale())}
                                      </span>
                                    </li>
                                  ))}
                                </ul>
                              ) : (
                                <div style={{ marginTop: 8, color: "var(--theme-text-muted, #666)", fontStyle: 'italic' }}><EmptyState icon={FileText} title={tr("Нет документов")} compact /></div>
                              )}
                            </div>
                          </div>
                        </td>
                      </tr>
                    ))}
                    {tr(editingOperatorByTopBase[tb.id] === op.id && (
                      <tr>
                        <td colSpan={7}>
                          <div style={{ padding: 8 }}>
                            <label>{tr("Сотрудник")}</label>
                            <select value={(editPayloads[`operator_${tb.id}_${op.id}`] || {}).employee || ''} onChange={(e) => setEditPayloads(p => ({ ...p, [`operator_${tb.id}_${op.id}`]: { ...p[`operator_${tb.id}_${op.id}`], employee: Number(e.target.value) } }))}>
                              <option value="">{tr("— Выберите сотрудника —")}</option>
                              {employees.map(emp => (<option key={emp.id} value={emp.id}>{tr(emp.label)}</option>))}
                            </select>
                            <label style={{ marginLeft: 8 }}>{tr("Телефон")}</label>
                            <input value={(editPayloads[`operator_${tb.id}_${op.id}`] || {}).phone || ''} onChange={(e) => setEditPayloads(p => ({ ...p, [`operator_${tb.id}_${op.id}`]: { ...p[`operator_${tb.id}_${op.id}`], phone: e.target.value } }))} />
                            <label style={{ marginLeft: 8 }}>{tr("Активен")}</label>
                            <input type="checkbox" checked={(editPayloads[`operator_${tb.id}_${op.id}`] || {}).is_active || false} onChange={(e) => setEditPayloads(p => ({ ...p, [`operator_${tb.id}_${op.id}`]: { ...p[`operator_${tb.id}_${op.id}`], is_active: e.target.checked } }))} />

                            <div style={{ marginTop: 8 }}>
                              <label>{tr("Документы")}</label>
                              <LocalizedFileInput
                                type="file"
                                multiple
                                accept=".pdf,.doc,.docx,.jpg,.jpeg,.png,.webp"
                                onChange={(e) => {
                                  const files = Array.from(e.target.files || [])
                                  setEditPayloads(p => ({
                                    ...p,
                                    [`operator_${tb.id}_${op.id}`]: {
                                      ...p[`operator_${tb.id}_${op.id}`],
                                      newDocuments: files
                                    }
                                  }))
                                }}
                              />
                              {tr(op.documents && op.documents.length > 0 && (
                                <div style={{ marginTop: 4, fontSize: '0.9em' }}>
                                  <strong>{tr("Текущие документы:")}</strong>
                                  <ul style={{ margin: '4px 0', paddingLeft: 20 }}>
                                    {op.documents.map(doc => (
                                      <li key={doc.id}>
                                        <a href={doc.file_url} target="_blank" rel="noopener noreferrer">
                                          {tr(doc.file_name)}
                                        </a>
                                      </li>
                                    ))}
                                  </ul>
                                </div>
                              ))}
                            </div>

                            <div className={styles.actionGroup} style={{ marginTop: 8 }}>
                              <button className={styles.btn_pin} onClick={() => saveEdit('operator', { topBase: tb.id, opId: op.id })}><Save size={14} aria-hidden="true"/>{tr(" Сохранить")}</button>
                              <button className={styles.btn_pin_close} onClick={() => cancelEdit('operator', { topBase: tb.id })}><X size={14} aria-hidden="true"/>{tr(" Отмена")}</button>
                            </div>
                          </div>
                        </td>
                      </tr>
                    ))}
                  </React.Fragment>
                ))}
              </tbody>
            </ResponsiveTable>
            {tr((!operatorsFilter && operatorsPagination && operatorsPagination.count > 0) && (
              <div className={styles.pagination}>
                <button disabled={!operatorsPagination.previous} onClick={() => loadOperatorsByTopBasePage(tb.id, (operatorsPagination.page || 1) - 1)}><ChevronLeft size={14} aria-hidden="true"/>{tr(" Пред.")}</button>
                <span>{tr("Стр. ")}{tr(operatorsPagination.page || 1)}{tr(" — Всего: ")}{tr(operatorsPagination.count)}</span>
                <button disabled={!operatorsPagination.next} onClick={() => loadOperatorsByTopBasePage(tb.id, (operatorsPagination.page || 1) + 1)}><ChevronRight size={14} aria-hidden="true"/>{tr(" След.")}</button>
              </div>
            ))}
          </>
        ) : (
          <div><EmptyState icon={UsersRound} title={tr("Операторы не найдены")} compact /></div>
        )}
      </div>
    </div>
  )
}

export default OperatorsList
